import { useMutation } from '@tanstack/react-query';
import { API } from '@/utils/API';

export interface BulkInvitationRow {
  email: string;
  role_key: string;
}

export interface BulkInvitationResult extends BulkInvitationRow {
  status: 'invited' | 'failed';
  error: string | null;
}

interface BulkInviteResponse {
  results: BulkInvitationResult[];
  invited_count: number;
  failed_count: number;
}

const postBulkInvitations = async (
  bulkInvitationsPath: string,
  invitations: BulkInvitationRow[]
): Promise<BulkInviteResponse> => {
  const response = await API.authenticated.fetch(bulkInvitationsPath, {
    method: 'POST',
    body: JSON.stringify({ bulk_invitation: { invitations } }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'Failed to send invitations');
  }

  return data as BulkInviteResponse;
};

export const useBulkInviteUsers = (bulkInvitationsPath: string) => {
  return useMutation({
    mutationFn: (invitations: BulkInvitationRow[]) =>
      postBulkInvitations(bulkInvitationsPath, invitations),
  });
};
